// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"FloatingButton_floatingButton__me07v","floating-icon":"FloatingButton_floating-icon__1f7O9","bounce_613":"FloatingButton_bounce_613__1L0Yb"};